export const SYSTEM_SECTION_TITLE = 'System';
export const REPORTS_SECTION_TITLE = 'Reports';
export const REPORTS_MORE_ITEM_NAME = 'More';
export const EVENTS_MANAGER_ITEM_NAME = 'Events Manager';
export const META_EMQ_ITEM_NAME = 'Meta EMQ';
export const DATA_SOURCES_ITEM_NAME = 'Data Sources';
export const DESTINATIONS_ITEM_NAME = 'Destinations';
export const NOTIFICATIONS_ITEM_NAME = 'Notifications';
